var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgSmile(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 30 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M24.75 12c0-3.469-1.875-6.656-4.875-8.438-3.047-1.734-6.75-1.734-9.75 0C7.078 5.345 5.25 8.532 5.25 12c0 3.516 1.828 6.703 4.875 8.484 3 1.735 6.703 1.735 9.75 0 3-1.78 4.875-4.968 4.875-8.484zM3 12A11.91 11.91 0 019 1.64c3.703-2.156 8.25-2.156 12 0 3.703 2.157 6 6.094 6 10.36 0 4.313-2.297 8.25-6 10.406-3.75 2.157-8.297 2.157-12 0C5.25 20.25 3 16.313 3 12zm8.297 2.953C12 15.703 13.219 16.5 15 16.5c1.734 0 2.953-.797 3.656-1.547a1.12 1.12 0 011.594-.094c.469.422.469 1.125.047 1.594A7.119 7.119 0 0115 18.75c-2.531 0-4.313-1.172-5.344-2.297a1.161 1.161 0 01.047-1.594 1.12 1.12 0 011.594.094zM9.75 9.75c0-.797.656-1.5 1.5-1.5s1.5.703 1.5 1.5c0 .844-.656 1.5-1.5 1.5a1.48 1.48 0 01-1.5-1.5zm9-1.5c.844 0 1.5.703 1.5 1.5 0 .844-.656 1.5-1.5 1.5a1.48 1.48 0 01-1.5-1.5c0-.797.656-1.5 1.5-1.5z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgSmile);
export default ForwardRef;
